// extracted by mini-css-extract-plugin
module.exports = {"AboutUsText":"AboutUsText_AboutUsText__WRmbf"};